import { Box } from "@mui/material";
import { useEffect, useState } from "react";

import {
  captcha,
  captchaSubMsg,
  captchaCode as captchaLabel,
  captchaCodePlaceholder,
  submit,
  invalidCaptchaCode,
} from "./messages";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";
import { Input } from "./input/Input";
import Text from "./text/Text";
import { captchaBackgroundColor, captchaDigit } from "./constants";
import InvalidErrorModal from "./InvalidErrorModal";

function CaptchaModal({
  isFromBrowser,
  isShowErrorModal,
  setIsShowErrorModal,
  handleValidCaptcha,
}) {
  const [captchaCode, setCaptchaCode] = useState(null);
  const [isButtonDisable, setIsButtonDisable] = useState(true);
  const [isInvalidCaptcha, setIsInvalidCaptcha] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      loadCaptchaEnginge(captchaDigit, captchaBackgroundColor);
    }, 0);
  }, []);

  useEffect(() => {
    setIsButtonDisable(captchaCode === null || captchaCode === "");
  }, [captchaCode]);

  const handleModalClose = () => {
    setIsShowErrorModal(false);
  };

  const handleSubmitCaptcha = () => {
    if (validateCaptcha(captchaCode) == true) {
      setIsShowErrorModal(false);
      handleValidCaptcha();
    } else {
      setIsInvalidCaptcha(true);
    }
  };

  const renderCaptcha = () => {
    return (
      <Box mt="10px" width="100%">
        <LoadCanvasTemplate />
        <Input
          fullWidth
          showLabel
          value={captchaCode}
          label={captchaLabel}
          onChange={(e) => {
            setIsInvalidCaptcha(false);
            setCaptchaCode(e.target.value);
          }}
          type="text"
          inputProps={{ maxLength: 6 }}
          customClass="mt-8"
          placeholder={captchaCodePlaceholder}
        />
        {isInvalidCaptcha && (
          <Text
            className="error-text"
            size={16}
            font="regular"
            sx={{ textAlign: "left", marginTop: "5px" }}
          >
            {invalidCaptchaCode}
          </Text>
        )}
      </Box>
    );
  };
  return (
    <Box>
      <InvalidErrorModal
        isFromBrowser={isFromBrowser}
        isOpenInvalidQRModal={isShowErrorModal}
        setIsOpenInvalidQRModal={setIsShowErrorModal}
        handleModalClose={handleModalClose}
        icon={"fail"}
        message={captcha}
        subMessage={captchaSubMsg}
        isShowHelpSection={false}
        direction={"up"}
        customClass={isFromBrowser ? "error-modal-wrapper-options" : ""}
        isShowErrorSection={false}
        additionalFeature={renderCaptcha}
        isAdditionalFeature={true}
        btnTxt={submit}
        handleButtonAction={handleSubmitCaptcha}
        isButtonDisable={isButtonDisable}
      />
    </Box>
  );
}

export default CaptchaModal;
